const items = [
    "Noida International Airport — Jewar",
    "YEIDA Authority Plots",
    "Registry Support Included",
    "Sectors 8 to 34 Covered",
    "Two Offices in Greater Noida",
    "Semi Commercial Plot Specialists Since 2013",
];

const Marquee = () => (
    <div className="bg-gold overflow-hidden py-3 border-y border-navy/10" data-testid="editorial-marquee" aria-hidden="true">
        <div className="flex w-max animate-marquee">
            {[0, 1].map((n) => (
                <div key={n} className="flex shrink-0">
                    {items.map((t, i) => (
                        <span key={`${n}-${i}`} className="flex items-center text-navy font-sans text-xs uppercase tracking-[1.4px] font-semibold px-6">
                            {t}
                            <span className="ml-12 w-1.5 h-1.5 rotate-45 bg-navy/40 inline-block" />
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default Marquee;
